import React from "react"
import types from "prop-types"
import { formOptionShape, categoryOptionShape } from "utils/propTypeShapes"
import AuthenticityTokenField from "./AuthenticityTokenField"
import BaseFormIdField from "./BaseFormIdField"
import TargetCategoryIdField from "./TargetCategoryIdField"

const CopyFormToOrganizationFormFields = ({
  sourceForms, targetCategories, selectedFormIds, onChange,
}) => (
  <>
    <AuthenticityTokenField />
    <BaseFormIdField forms={sourceForms} selectedFormIds={selectedFormIds} onChange={onChange} />
    <TargetCategoryIdField categories={targetCategories} />
  </>
)

CopyFormToOrganizationFormFields.propTypes = {
  sourceForms: types.arrayOf(formOptionShape).isRequired,
  targetCategories: types.arrayOf(categoryOptionShape).isRequired,
  selectedFormIds: types.arrayOf(Number).isRequired,
  onChange: types.func.isRequired,
}

export default CopyFormToOrganizationFormFields
